import { BoxGeometry, Mesh, MeshStandardMaterial } from "three";

import { disposeObject } from "../../render/utilities/disposeObject";
import { WorldObject } from "../../render/world/WorldObject";
import { DARK_TILE_COLOR, LIGHT_TILE_COLOR, TILE_ROUGHNESS, TILE_THICKNESS } from "../../constants";
import { TILE_OFFSETS } from "../viewerConstants";

export class ViewerBoardPatch extends WorldObject {
  constructor() {
    super();
    const geometry = new BoxGeometry(1, TILE_THICKNESS, 1);
    const light = new MeshStandardMaterial({ color: LIGHT_TILE_COLOR, roughness: TILE_ROUGHNESS });
    const dark = new MeshStandardMaterial({ color: DARK_TILE_COLOR, roughness: TILE_ROUGHNESS });

    for (const x of TILE_OFFSETS) {
      for (const z of TILE_OFFSETS) {
        const tile = new Mesh(geometry, (x + z) % 2 === 0 ? light : dark);
        tile.position.set(x, -TILE_THICKNESS / 2, z);
        tile.receiveShadow = true;
        this.root.add(tile);
      }
    }
  }

  dispose() {
    disposeObject(this.root);
  }
}
